import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cellStyle' })
export class CellStylePipe implements PipeTransform {
    transform(color: string | null | undefined): object {
        if (!color) return {};
        return {
            'background-color': color,
            'font-weight': '700'
        };
    }
}